import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import { CounterpartyAddress } from "@common/schemas/counterpartyAddress.schema";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { formatCounterpartyAddressLines } from "@components/counterparty/counterpartyBookFormat";

export const CounterpartyAddressLinesCell = memo(
    ({ row }: CellContext<ViewTableFeatures, CounterpartyAddress, string>) => (
        <ViewTableCell>
            {formatCounterpartyAddressLines(row.original).join(", ") || "-"}
        </ViewTableCell>
    ),
);

CounterpartyAddressLinesCell.displayName = "CounterpartyAddressLinesCell";
